const sanitizeFileNameString = (name: string) => {
    return name.replace(/[\\/:*?"<>|]+/g, "_");
};

export function sanitizeFileName(file: File): File {
    const sanitizedFileName = sanitizeFileNameString(file?.name ?? "");

    if (sanitizedFileName !== file.name) {
        return new File([file], sanitizedFileName, { type: file.type });
    }
    return file;
}
